@import 'styles/mixins';
@import 'styles/variables';

.overflowPopover {
  max-height: 205px;
  overflow-y: auto;
  width: 240px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .overflowPopoverRow {
    @include md-regular;

    background-color: $white;
    border-radius: 4px;
    color: $grey-50;
    cursor: pointer;
    justify-content: flex-start;
    padding: 8px;
    width: 100%;

    &:hover {
      background-color: $grey-5;
    }
  }
  > .overflowPopoverRow + .overflowPopoverRow {
    margin: 4px 0;
  }
}

.overflowTrigger {
  min-height: 36px;
}

.breadcrumb {
  @include md-regular;

  align-items: center;
  border-radius: 4px;
  color: $grey-50;
  display: flex;
  gap: 2px;

  &.defaultProject {
    svg {
      margin: 0 8px 0 4px;
    }
  }

  .text {
    @include line-clamp();

    max-width: 200px;
  }

  &.defaultProject {
    svg {
      margin: 0 4px;
    }
  }

  svg {
    fill: transparent !important;
    margin-right: 8px;
    min-width: 16px;
    min-height: 16px;
  }
}

.divider {
  color: $grey-20;
  margin: 0 2px;
}
